const getDateAsLocaleString = (date: string) => {
    return new Date(date).toLocaleString()
}

export { getDateAsLocaleString }
